import React, { useEffect, useState } from 'react';
import '../My-assessment/myAssessment.scss';
import './reports.scss';
import { Table } from 'react-bootstrap';
import { getAssessmentIssues, resetLoading } from '../../Redux/ActionCreators/reportAction';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { convertDate, formatAMPM } from '../../utils/miscelleneous';
import moment from 'moment';

const ISSUE_TYPES = [
    'Wrong Question',
    'Wrong Answer',
    'Question Not Visible',
    'Image/Code Missing',
    'Technical Issue',
    'Other',
];

const ISSUE_TYPE_CLASS_MAP = {
    'Wrong Question': 'ri-issue-badge--wrong-question',
    'Wrong Answer': 'ri-issue-badge--wrong-answer',
    'Question Not Visible': 'ri-issue-badge--question-not-visible',
    'Image/Code Missing': 'ri-issue-badge--image-code-missing',
    'Technical Issue': 'ri-issue-badge--technical-issue',
    'Other': 'ri-issue-badge--other',
};

const ExternalLinkIcon = () => (
  <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" />
    <polyline points="15 3 21 3 21 9" />
    <line x1="10" y1="14" x2="21" y2="3" />
  </svg>
);

const PersonIcon = () => (
  <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
    <circle cx="12" cy="7" r="4" />
  </svg>
);

const DocumentIcon = () => (
  <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
    <polyline points="14 2 14 8 20 8" />
  </svg>
);

const InfoCircleIcon = () => (
  <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="10" />
    <line x1="12" y1="8" x2="12" y2="12" />
    <line x1="12" y1="16" x2="12.01" y2="16" />
  </svg>
);

const EditIcon = () => (
  <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
    <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" />
  </svg>
);

const CopyIcon = () => (
  <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <rect x="9" y="9" width="13" height="13" rx="2" ry="2" />
    <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" />
  </svg>
);

export default function ReportedIssues() {
    const [page, setPage] = useState(1);
    const [query, setQuery] = useState('');
    const [issueType, setIssueType] = useState('');
    const [orderBy, setOrderBy] = useState('CreatedAt');
    const [orderDirection, setOrderDirection] = useState('DESC');
    const [selectedIssue, setSelectedIssue] = useState(null);
    const [copiedId, setCopiedId] = useState(false);
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { isReportLoading, assessmentIssues, assessmentIssuesTotalCount } = useSelector(state => state.report);

    const [itemsPerPage, setItemsPerPage] = useState(10);
    const timerRef = React.useRef(null);
    const isMobile = window.innerWidth < 767;

    let tenantID = null;
    try {
        const stored = localStorage.getItem("profileDetails");
        if (stored) {
            const parsed = JSON.parse(stored);
            tenantID = parsed?.tenentId || null;
        }
    } catch (err) {
        tenantID = null;
    }

    useEffect(() => {
        if (!tenantID) {
            navigate("/login");
        }
    }, [tenantID, navigate]);

    useEffect(() => {
        dispatch(resetLoading());
        dispatch(getAssessmentIssues({ pageNumber: 1, pageSize: itemsPerPage, searchText: '', issueType: '', orderBy, orderDirection }));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dispatch, orderBy, orderDirection]);

    const fetchIssues = (params) => {
        dispatch(getAssessmentIssues({
            pageNumber: params.page,
            pageSize: itemsPerPage,
            searchText: params.query,
            issueType: params.issueType,
            orderBy: params.orderBy || orderBy,
            orderDirection: params.orderDirection || orderDirection,
        }));
    };

    const searchIssues = (val) => {
        clearTimeout(timerRef.current);
        setQuery(val);
        setPage(1);
        timerRef.current = setTimeout(() => {
            dispatch(resetLoading());
            fetchIssues({ page: 1, query: val, issueType });
        }, 800);
    };

    const onIssueTypeChange = (val) => {
        setIssueType(val);
        setPage(1);
        dispatch(resetLoading());
        fetchIssues({ page: 1, query, issueType: val });
    };

    const onSortChange = (field) => {
        if (orderBy === field) {
            const newDir = orderDirection === 'DESC' ? 'ASC' : 'DESC';
            setOrderDirection(newDir);
            dispatch(resetLoading());
            fetchIssues({ page, query, issueType, orderBy: field, orderDirection: newDir });
        } else {
            setOrderBy(field);
            setOrderDirection('DESC');
            dispatch(resetLoading());
            fetchIssues({ page, query, issueType, orderBy: field, orderDirection: 'DESC' });
        }
    };

    const paginate = (pageNumber) => {
        const totalPages = Math.ceil((assessmentIssuesTotalCount || 0) / itemsPerPage);
        if (pageNumber < 1 || pageNumber > totalPages) return;
        setPage(pageNumber);
        dispatch(resetLoading());
        fetchIssues({ page: pageNumber, query, issueType });
    };

    const onPageSizeChange = (val) => {
        const size = parseInt(val, 10);
        setItemsPerPage(size);
        setPage(1);
        dispatch(resetLoading());
        dispatch(getAssessmentIssues({ pageNumber: 1, pageSize: size, searchText: query, issueType, orderBy, orderDirection }));
    };

    const navigateToQuestion = (mode) => {
        const issue = selectedIssue;
        const isView = mode === 'view';

        if (!issue.isCodingQuestion) {
            navigate('/create', {
                state: {
                    edit: true,
                    view: isView,
                    detail: { questionID: issue.questionId, questionTypeID: issue.questionType },
                    question: true,
                },
            });
        } else {
            navigate('/create', {
                state: {
                    edit: true,
                    view: isView,
                    detail: { id: issue.questionId, questionTypeID: issue.questionType, version: issue.questionVersion },
                    question: true,
                },
            });
        }
    };

    const copyIssueId = (id) => {
        if (!id) return;
        navigator.clipboard.writeText(String(id)).then(() => {
            setCopiedId(true);
            setTimeout(() => setCopiedId(false), 2000);
        });
    };

    const navigateToReport = () => {
        navigate('/test-report', {
            state: {
                id: selectedIssue.inviteId,
                type: 'new',
                myTest: false,
                path: 'report',
            },
        });
    };

    const totalPages = Math.ceil((assessmentIssuesTotalCount || 0) / itemsPerPage);
    const currentDataLength = assessmentIssues?.length || 0;
    const hasData = assessmentIssues && assessmentIssues.length > 0;
    const showTableOverlay = isReportLoading && hasData;
    const showFullLoading = isReportLoading && !hasData;

    const getPageNumbers = () => {
        if (totalPages <= 4) return Array.from({ length: totalPages }, (_, i) => i + 1);
        if (page <= 3) return [1, 2, 3, '...', totalPages];
        if (page >= totalPages - 2) return [1, '...', totalPages - 2, totalPages - 1, totalPages];
        return [1, '...', page - 1, page, page + 1, '...', totalPages];
    };

    const SortIcon = ({ field }) => {
        if (orderBy !== field) return <span className="ri-sort-icon ri-sort-icon--inactive">↕</span>;
        return <span className="ri-sort-icon">{orderDirection === 'DESC' ? '↓' : '↑'}</span>;
    };

    // Derived flags for the selected issue popup
    const hasValidQuestion = !!(selectedIssue?.questionId && selectedIssue.questionId !== 0);
    const canViewQuestion = hasValidQuestion && selectedIssue?.canView === true;
    const canEditQuestion = hasValidQuestion && selectedIssue?.canEdit === true;
    const viewReportEnabled = selectedIssue && ![1, 2].includes(selectedIssue.candidateTestStatus);
    const showViewHint = selectedIssue && !selectedIssue.canView && selectedIssue.canViewHint;
    const showEditHint = selectedIssue && !selectedIssue.canEdit && selectedIssue.canEditHint;

    return (
        <div className='gappeo-my-tests'>
            <div className='ri-page-header d-flex flex-wrap justify-content-between align-items-center'>
                <div className='d-flex align-items-center gap-2'>
                    <img
                        src="/images/leftarrow-black-icon.svg"
                        alt="Back"
                        width={30}
                        height={30}
                        className="ri-back-btn"
                        onClick={() => navigate('/reports')}
                    />
                    <h1 className="ri-page-title">Reported Issues</h1>
                </div>
            </div>

            <div className="table-admin">
                <div className='search-test mt-1 d-flex align-items-center gap-2' style={{ marginBottom: isMobile ? '12px' : ''}}>
                    <div className="has-search ri-search-input">
                        <span className="form-control-feedback">
                            <img src="/images/search.svg" alt='' width={12} />
                        </span>
                        <input
                            type="text"
                            className="form-control"
                            value={query}
                            placeholder="Search by candidate, Issue id"
                            onChange={(e) => searchIssues(e.target.value)}
                        />
                    </div>
                    <div className="ri-filter-select">
                        <select className='form-control' value={issueType} onChange={(e) => onIssueTypeChange(e.target.value)}>
                            <option value=''>All Issue Types</option>
                            {ISSUE_TYPES.map(t => (
                                <option key={t} value={t}>{t}</option>
                            ))}
                        </select>
                    </div>
                    <div className="ri-sort-select">
                        <select className='form-control' value={orderBy} onChange={(e) => onSortChange(e.target.value)}>
                            <option value='CreatedAt'>Sort: Date</option>
                            <option value='IssueType'>Sort: Issue Type</option>
                            <option value='CandidateName'>Sort: Candidate</option>
                            <option value='TestName'>Sort: Assessment</option>
                        </select>
                    </div>
                </div>

                {showFullLoading ? (
                    <div className="loading-overlay ri-loading">
                        <div className="spinner-border" role="status">
                            <span className="visually-hidden">Loading...</span>
                        </div>
                    </div>
                ) : hasData ? (
                    <>
                        {!isMobile ? (
                            <Table responsive className='assessment-table'>
                                <thead>
                                    <tr>
                                        <th>Issue ID</th>
                                        <th className="ri-sortable-th" onClick={() => onSortChange('CandidateName')}>
                                            Name <SortIcon field='CandidateName' />
                                        </th>
                                        <th>Email</th>
                                        <th className="ri-sortable-th" onClick={() => onSortChange('TestName')}>
                                            Assessment <SortIcon field='TestName' />
                                        </th>
                                        <th className="ri-sortable-th" onClick={() => onSortChange('IssueType')}>
                                            Issue Type <SortIcon field='IssueType' />
                                        </th>
                                        <th className="ri-sortable-th" onClick={() => onSortChange('CreatedAt')}>
                                            Reported At <SortIcon field='CreatedAt' />
                                        </th>
                                        <th>Action</th>
                                    </tr>
                                </thead>
                                <tbody className="table-body">
                                    {showTableOverlay ? (
                                        <tr>
                                            <td colSpan={7} className="ri-tbody-spinner-cell">
                                                <div className="spinner-border ri-spinner" role="status">
                                                    <span className="visually-hidden">Loading...</span>
                                                </div>
                                            </td>
                                        </tr>
                                    ) : (
                                        assessmentIssues.map((el, index) => (
                                            <tr key={index}>
                                                <td>
                                                    <span className="ri-issue-id-cell">{el.issueId || '—'}</span>
                                                </td>
                                                <td><strong className="ri-candidate-name">{el.candidateName}</strong></td>
                                                <td>{el.candidateEmail}</td>
                                                <td>{el.testName}</td>
                                                <td>
                                                    <span className={`ri-issue-badge ${ISSUE_TYPE_CLASS_MAP[el.issueType] || ''}`}>{el.issueType}</span>
                                                </td>
                                                <td>
                                                    {el.createdAt ? convertDate(el.createdAt) : ''}
                                                    <br />
                                                    {el.createdAt ? formatAMPM(moment.utc(el.createdAt).local().format()) : ''}
                                                </td>
                                                <td>
                                                    <img
                                                        src='/images/view-icon.svg'
                                                        alt='View'
                                                        className='ri-action-icon cursor-pointer'
                                                        onClick={() => setSelectedIssue(el)}
                                                        title='View'
                                                    />
                                                </td>
                                            </tr>
                                        ))
                                    )}
                                </tbody>
                            </Table>
                        ) : (
                            showTableOverlay ? (
                                <div className="ri-list-spinner">
                                    <div className="spinner-border ri-spinner" role="status">
                                        <span className="visually-hidden">Loading...</span>
                                    </div>
                                </div>
                            ) : (
                                <div className='report-list'>
                                    {assessmentIssues.map((el, index) => (
                                        <div className='report-item' key={index}>
                                            <div className='d-flex justify-content-between align-items-center'>
                                                <div>
                                                    <h4>{el.candidateName}</h4>
                                                    <h5>{el.candidateEmail}</h5>
                                                </div>
                                                <div className="d-flex align-items-center gap-2">
                                                    <span className={`ri-issue-badge ${ISSUE_TYPE_CLASS_MAP[el.issueType] || ''}`}>{el.issueType}</span>
                                                    <img
                                                        src='/images/view-icon.svg'
                                                        alt='View'
                                                        className='ri-action-icon cursor-pointer'
                                                        onClick={() => setSelectedIssue(el)}
                                                        title='View'
                                                    />
                                                </div>
                                            </div>
                                            <hr className="ri-divider" />
                                            <div>
                                                <p className="ri-mb-1"><strong>Test:</strong> {el.testName}</p>
                                                <p className="ri-mb-1"><strong>Issue ID:</strong> <span className="ri-issue-id-cell">{el.issueId || '—'}</span></p>
                                                {el.description && <p className="ri-mobile-description">{el.description}</p>}
                                                <p className="ri-mobile-date">
                                                    {el.createdAt ? convertDate(el.createdAt) : ''}{' '}
                                                    {el.createdAt ? formatAMPM(moment.utc(el.createdAt).local().format()) : ''}
                                                </p>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            )
                        )}
                        {!showTableOverlay && (
                            <div className={`pagination d-flex flex-wrap align-items-center justify-content-between${isMobile ? ' ri-pagination-mobile' : ''}`}>
                                <div className="d-flex flex-wrap" style={{ gap: isMobile ? '10px' : '20px' }}>
                                    <div className="pagination-info d-flex align-items-center">
                                        {currentDataLength > 0 ? (
                                            <span>
                                                Showing <strong>{(page - 1) * itemsPerPage + 1}</strong>-
                                                <strong>{(page - 1) * itemsPerPage + currentDataLength}</strong> of <strong>{assessmentIssuesTotalCount}</strong>
                                            </span>
                                        ) : (
                                            <span>Showing 0-0 of 0</span>
                                        )}
                                    </div>
                                </div>
                                <div className="d-flex align-items-center">
                                    <div className="pagination-buttons">
                                        <button onClick={() => paginate(page - 1)} disabled={page === 1}>
                                            <img src="/images/leftarrow-icon.svg" alt="" />
                                        </button>
                                        {getPageNumbers().map((pageNum, index) => (
                                            <button
                                                key={index}
                                                onClick={() => (pageNum === '...' ? null : paginate(pageNum))}
                                                className={page === pageNum ? 'active' : ''}
                                                disabled={pageNum === '...'}
                                            >
                                                {pageNum}
                                            </button>
                                        ))}
                                        <button onClick={() => paginate(page + 1)} disabled={page === totalPages || totalPages === 0}>
                                            <img src="/images/leftarrow-icon.svg" alt="" className="ri-arrow-reverse" />
                                        </button>
                                    </div>
                                    <span style={{ color: '#525B66', lineHeight: '100%' }}>Per page</span>
                                    <select
                                        value={itemsPerPage}
                                        onChange={(e) => onPageSizeChange(e.target.value)}
                                        style={{ width: '46px', height: '32px', borderRadius: '2px', border: '1px solid #8A9199', color: '#8A9199' }}
                                    >
                                        <option value={10}>10</option>
                                        <option value={25}>25</option>
                                        <option value={50}>50</option>
                                        <option value={100}>100</option>
                                    </select>
                                </div>
                            </div>
                        )}
                    </>
                ) : (
                    <div className='empty-list'>
                        <img src='/images/magnifier.svg' alt='' />
                        <div className='mt-2'>
                            <h3>No reported issues found</h3>
                        </div>
                    </div>
                )}
            </div>

            {copiedId && (
                <div className="ri-copy-snackbar">Copied</div>
            )}

            {selectedIssue && (
                <div className="upload-modal automation-modal ri-issue-modal">
                    <div className="modal-content">
                        <div className="modal-head">
                            <h3>Reported Issue Details</h3>
                            <img
                                src="/images/close-icon.svg"
                                alt="close"
                                className="cursor-pointer"
                                onClick={() => setSelectedIssue(null)}
                            />
                        </div>

                        <div className="modal-input">
                            {/* Top 2-column info grid — all cells are direct children so rows align */}
                            <div className="ri-modal-info-grid">
                                {/* Row 1: section headers */}
                                <div className="ri-grid-cell-header ri-grid-cell-header--between">
                                    <div className="d-flex align-items-center gap-1">
                                        <PersonIcon />
                                        <span className="ri-col-label">Candidate</span>
                                    </div>
                                    <button
                                        className={`ri-icon-action-btn${!viewReportEnabled ? ' ri-icon-action-btn--disabled' : ''}`}
                                        disabled={!viewReportEnabled}
                                        onClick={navigateToReport}
                                        title="View Report"
                                    >
                                        <ExternalLinkIcon />
                                    </button>
                                </div>
                                <div className="ri-grid-cell-header">
                                    <div className="d-flex align-items-center gap-1">
                                        <DocumentIcon />
                                        <span className="ri-col-label">Issue ID</span>
                                    </div>
                                </div>

                                {/* Row 2: primary values */}
                                <p className="ri-value-primary">{selectedIssue.candidateName || '—'}</p>
                                <div className="d-flex align-items-center gap-1">
                                    <p className="ri-value-primary" style={{ margin: 0 }}>{selectedIssue.issueId || '—'}</p>
                                    {selectedIssue.issueId && (
                                        <button
                                            className="ri-icon-action-btn"
                                            onClick={() => copyIssueId(selectedIssue.issueId)}
                                            title="Copy Issue ID"
                                            style={{alignItems:'unset', paddingTop:'4px'}}
                                        >
                                            <CopyIcon />
                                        </button>
                                    )}
                                </div>

                                {/* Row 3: labels */}
                                <span className="ri-col-label">Email</span>
                                <span className="ri-col-label">Assessment</span>

                                {/* Row 4: values */}
                                <p className="ri-read-value">{selectedIssue.candidateEmail || '—'}</p>
                                <p className="ri-read-value">{selectedIssue.testName || '—'}</p>

                                {/* Row 5: labels */}
                                <span className="ri-col-label ri-mt-8">Reported At</span>
                                <span className="ri-col-label ri-mt-8">Issue Type</span>

                                {/* Row 6: values */}
                                <p className="ri-read-value">
                                    {selectedIssue.createdAt
                                        ? `${convertDate(selectedIssue.createdAt)} ${formatAMPM(moment.utc(selectedIssue.createdAt).local().format())}`
                                        : '—'}
                                </p>
                                <span className={`ri-issue-badge ${ISSUE_TYPE_CLASS_MAP[selectedIssue.issueType] || ''}`}>
                                    {selectedIssue.issueType || '—'}
                                </span>
                            </div>

                            {/* Question section */}
                            {hasValidQuestion && (
                                <div className="ri-section-block">
                                    <div className="ri-section-block__header">
                                        <div className="d-flex align-items-center gap-1">
                                            <InfoCircleIcon />
                                            <span className="ri-col-label">Question</span>
                                        </div>
                                        <div className="d-flex align-items-center gap-1">
                                            <button
                                                className={`ri-icon-action-btn${!canViewQuestion ? ' ri-icon-action-btn--disabled' : ''}`}
                                                disabled={!canViewQuestion}
                                                onClick={() => navigateToQuestion('view')}
                                                title={canViewQuestion ? 'View Question' : (selectedIssue.canViewHint || 'Cannot view')}
                                            >
                                                <ExternalLinkIcon />
                                            </button>
                                            <button
                                                className={`ri-icon-action-btn${!canEditQuestion ? ' ri-icon-action-btn--disabled' : ''}`}
                                                disabled={!canEditQuestion}
                                                onClick={() => navigateToQuestion('edit')}
                                                title={canEditQuestion ? 'Edit Question' : (selectedIssue.canEditHint || 'Cannot edit')}
                                            >
                                                <EditIcon />
                                            </button>
                                        </div>
                                    </div>
                                    {selectedIssue.questionText && (
                                        <div className="ri-content-box ri-detail-html" dangerouslySetInnerHTML={{ __html: selectedIssue.questionText }} />
                                    )}
                                    {!selectedIssue.questionText && (
                                        <div className="ri-content-box">
                                            <p className="ri-read-value">—</p>
                                        </div>
                                    )}
                                </div>
                            )}

                            {/* Description section */}
                            {selectedIssue.description && (
                                <div className="ri-section-block ri-section-block--last">
                                    <span className="ri-col-label">Description</span>
                                    <div className="ri-content-box">
                                        <p className="ri-read-value">{selectedIssue.description}</p>
                                    </div>
                                </div>
                            )}

                            {/* Hints */}
                            {(showViewHint || showEditHint) && (
                                <div className="ri-hints ri-mt-12">
                                    {showViewHint && <p className="ri-hint-text">{selectedIssue.canViewHint}</p>}
                                    {showEditHint && <p className="ri-hint-text">{selectedIssue.canEditHint}</p>}
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}
